import { render, staticRenderFns } from "./TopicEdit.vue?vue&type=template&id=5f9606a6&scoped=true"
import script from "./TopicEdit.vue?vue&type=script&lang=js"
export * from "./TopicEdit.vue?vue&type=script&lang=js"
import style0 from "./TopicEdit.vue?vue&type=style&index=0&id=5f9606a6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9606a6",
  null
  
)

export default component.exports